<div class="dialog">
  <div class="animated-circle-icon huge orange">
    <app-svg src="/assets/icons/alert-circle.svg"></app-svg>
  </div>

  <h1>Approval Limit</h1>
  <p>
    You can only approve {{ gallery.approval_limits | abs }} assets. To change approvals, you need to un-approve other
    assets first.
  </p>

  <button
    appButton
    name="confirm"
    location="approval-limit-reached-dialog"
    color="primary"
    shape="round"
    height="4"
    size="3"
    spacing="full"
    (click)="close()"
  >
    Ok
  </button>
</div>
